import React, { Fragment } from "react";
function makeLegendAboutColorRule() {
  const LegendAboutColorRule = (
    <Fragment>
      <li className="yes-available-rule legend-example">{"Disponible"}</li>
      <li className="workInProgress-available-rule legend-example">
        {"J'avance dessus ces jours-ci"}
      </li>
      <li className="soon-available-rule legend-example">
        {"Ajouts que j'aimerai faire ensuite"}
      </li>
      <li className="later-available-rule legend-example">{"Plus tard"}</li>
      <li className="maybenever-available-rule legend-example">
        {"Bien plus tard"}
      </li>
    </Fragment>
  );
  return LegendAboutColorRule;
}
const TheFuture = () => {
  return (
    <main className="main-contactAndSources">
      <h2 style={{ marginBottom: "20px", marginTop: "20px" }}>
        Qu'apporteront les prochaines mises à jour, idéalement ?
        <br />
        (pas forcément dans cet ordre)
        <br />
      </h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          fontSize: 16,
        }}
      >
        <ul
          className="legend-about-colors"
          style={{
            marginRight: "10px",
            justifyContent: "center",
          }}
        >
          {makeLegendAboutColorRule()}
        </ul>
        <div
          style={{
            marginBottom: "10px",
          }}
        >
          <p style={{ color: "red" }}>
            Update 14/04/2025 : Probable énergie pour travailler dans les
            semaines qui viennent = 0%
          </p>
          <p className="yes-available-rule">
            Site remis en ligne le 6 février 2025. J'ai plein d'énergie pour
            refaire pleins d'ajouts, corriger pleins de vieux bugs ! Je
            travaille à une nouvelle interface, elle est déjà en partie en
            ligne.
          </p>
          <p className="yes-available-rule">
            Nouvelle interface, avec des fenêtres de différentes degré de
            couleur, et un set de couleur qui peuvent être choisies.
          </p>
          <p className="yes-available-rule">
            Mise en ligne des inférences minimales de chaque règle, en dernière
            catégorie des instructions de chaque règle.
          </p>
          <p className="yes-available-rule">
            Versions alternatives des règles ⊃e, ⊅e (les contrapositions), et ≡e
            (permettre d'avoir A si on A≡B et B, et inversement). Beaucoup de
            corrections de vieux bugs.
          </p>
          <p className="yes-available-rule">Interface pour smartphone.</p>
          <p className="yes-available-rule">
            Interface clavier d'ordinateur : flèche gauche et droite pour
            changer d'exercice.
          </p>
          <p className="workInProgress-available-rule">
            Adaptation du bac à sable à la nouvelle interface.
          </p>
          <p className="soon-available-rule">
            Affichage traditionnel des lignes d'hypothèse.
          </p>
          <p className="soon-available-rule">
            Version alternative de la règle ∨e (syllogisme disjonctif).
          </p>
          <p className="soon-available-rule">
            Faire que le commentaire d'inférence soit affiché normalement, pour
            les règles ∨e, ∨e', ⊻i, ⊻e.
            {/*(Note pour moi : tout est dans
            RuleProvider.js.)*/}
          </p>
          <p className="soon-available-rule">
            Permettre au RulePopover d'apparaitre aussi pour les contraposées
            (et vérifier si dans l'ensemble leur interface est bien cohérente).
          </p>
          <p className="soon-available-rule">
            Réfléchir à peut-être fusionner ≡e et ≡e' en une seule règle, avec
            une interface unique (pour qu'on puisse choisir soit d'extraire p de
            p≡q avec q (et inversement), soit extraire p⊃q et q⊃p sans
            prérequis).
          </p>
          <p className="workInProgress-available-rule">
            Interface clavier d'ordinateur : A Z E R T Y (etc) pour ouvrir une
            fenêtre de règles (et a z e r t y pour citer des prémisses,
            peut-être), 1 2 3 4 5 (etc) pour citer une certaine inférence, Echap
            pour fermer un modal/fenêtre ouverte (la fenêtre colorChoice, les
            modaux de règles, etc). Mettre un petite miniPopup dans les boutons
            d'options, qui décrira ces possibilités, et qui est
            activable/désactivable pour afficher une petite lettre ou chiffre à
            côté de l'élément concerné.
          </p>
          <p className="workInProgress-available-rule">
            Interface clavier d'ordinateur : pouvoir taper facilement au clavier
            (en associant les touches à des connecteurs de logique faciles à
            taper) le contenu des hypothèses, et pouvoir valider avec "entrée"
            ou effacer un caractère avec backspace.
          </p>
          <p className="soon-available-rule">
            Faire une vérification automatique de la cohérence du texte
            d'hypothèse qu'on a entré. Ajouter un petit text informatif
            optionnel pour expliquer ce que peut être une expression cohérente
            en logique avec des connecteurs unaires et binaires.
          </p>
          <p className="soon-available-rule">
            Faire "blinker" en vert la bordure de l'inférence qui correspondant
            à la solution recherchée pour l'exercice.
          </p>
          <p className="soon-available-rule">
            Pouvoir valider une inférence en cliquant sur sa prévisualisation.
          </p>
          <p className="soon-available-rule">
            Affichage alternatif des exercices (une ligne avec infos détaillées
            par exo, plutôt qu'une grille avec tous les exos.)
          </p>
          <p className="soon-available-rule">
            D'autres idées pas listables à l'occasion, corrections de bugs, et
            n'hésitez pas à me proposer des trucs !
          </p>
          <p className="soon-available-rule">
            0.75-0.80 : Un système de comptes utilisateur pour créer des exos,
            savoir quels exos on a résolus etc.
          </p>
          <p className="later-available-rule">
            0.80-0.90 : Les règles modales.
          </p>
          <p className="maybenever-available-rule">
            0.90-1.0 : Les règles des prédicats.
          </p>
          <p className="maybenever-available-rule">
            Version imprimable des sophismes.
          </p>
          {/*
          <p className="soon-available-rule">
            - La possibilité pour un utilisateur, de créer des exercices
            relatifs aux raisonnements fallacieux. Par exemple la phrase "La
            France, tu l'aimes ou tu la quittes" est au moins un faux dilemme et
            un appel à l'émotion, le but de l'exercice serait de trouver que
            c'est le cas.
          </p>
          <p className="soon-available-rule">
            - Des schémas pour indiquer quels genre d'arguments sont attendus
            pour chaque règle, et montrer aussi clairement que possible la
            compatibilité des règles avec les inférences en cours.
          </p>
          <p className="later-available-rule">
            - Faire un affichage plus traditionnel du niveau d'hypothèse, avec
            des traits qui s'adaptent à la longueur des hypothèses.
          </p>
          <p className="later-available-rule">
            - Une meilleure interface pour la liste des exercices, notamment
            pour mettre en avant les significations possibles.
          </p>
          <p className="maybenever-available-rule">
            - Au sein de la déduction, lorsqu'on met le curseur de la souris sur
            le caractère d'une parenthèse, l'autre caractère lié à ce premier
            caractère sera affiché en subrillance, et toute la portée contenue
            entre ces parenthèses sera soulignée.
          </p>
          <p className="maybenever-available-rule">
            - Un mode "tutoriel" activable/désactivable à volonté pour tous les
            exercices, qui dira à l'utilisateur où il doit cliquer et quand. En
            suivant sans réfléchir les indications de ce tutoriel, on devra
            pouvoir faire tous les exercices du site.
          </p>
          <p className="maybenever-available-rule">
            - Dans l'interface de la déduction, il faudrait un bouton qui
            permettrait de mettre dans le presse-papier a) toutes les prémisses,
            b) la conclusion, et c) toute la déduction en cours en affichant le
            niveau d'hypothèses par des barres verticales devant chaque ligne.
          </p>
          <p className="maybenever-available-rule">
            - Au sein de la déduction, pouvoir réduire instantanément une
            inférence ayant un symbole autre que ~ et ∧, par leur équivalent
            avec ces symboles. Une petite icône sur la ligne le permettra. Par
            exemple p⊃q se réduit à ~(~p∧q).
          </p>
          <p className="maybenever-available-rule">
            - Laisser la possibilité à l'utilisateur d'écrire les dernières
            lignes d'une déduction (avec un "?" à la place de leur nombre), dès
            le début (pour qu'il puisse établir à l'avance le but visé dans sa
            déduction).
          </p> */}
        </div>
      </div>
    </main>
  );
};

export default TheFuture;



// WEBPACK FOOTER //
// ./src/components/Pages/Secondary Pages/TheFuture.js